export default "__VITE_ASSET__B32i2Ccg__"